// extracted by mini-css-extract-plugin
export default {"dropdownButtonText":"DropdownElement-module__dropdownButtonText--gyY6a"};